import { EmptyArray } from './empty.js';
export { EmptyArray as EmptyIterable, EmptyArray };
export const EmptyIterator = EmptyArray[Symbol.iterator]();
export function* iterateSingle(value) {
    yield value;
}
export function single(iter) {
    let { value, done } = iter.next();
    if (done) {
        throw new Error('Iterator was empty; expected a single value');
    }
    done = iter.next().done;
    if (!done) {
        throw new Error('Iterator had more than one value; expected a single value');
    }
    return value;
}
/** Returns true as soon as there are count items returned by the iterable */
export function atLeastCount(iter, count) {
    let i = 0;
    for (const _ of iter) {
        if (++i >= count) {
            return true;
        }
    }
    return false;
}
export function* uniqBy(iter, keyFn) {
    const seen = new Set();
    for (const item of iter) {
        const key = keyFn(item);
        if (!seen.has(key)) {
            seen.add(key);
            yield item;
        }
    }
}
export async function* promiseOfIteratorToAsyncIterator(promise) {
    const iter = await promise;
    while (true) {
        const { value, done } = iter.next();
        if (done) {
            break;
        }
        yield value;
    }
}
//# sourceMappingURL=iterators.js.map